"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _RadioSwitch = _interopRequireDefault(require("./RadioSwitch"));
var _commonHelper = require("../helpers/commonHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Switch = function Switch(props) {
  var readOnly = props.readOnly,
    onToggle = props.onToggle,
    type = props.type,
    active = props.active,
    color = props.color,
    size = props.size,
    totalWidth = props.totalWidth,
    spacing = props.spacing,
    changeOnState = props.changeOnState;
  var _useState = (0, _react.useState)(active),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeState = _useState2[0],
    toggleActiveState = _useState2[1];
  var handlerFn = function handlerFn() {
    if (!readOnly) {
      !changeOnState && toggleActiveState(!activeState);
      onToggle(!activeState);
    }
  };
  (0, _react.useEffect)(function () {
    toggleActiveState(active);
  }, [active]);
  if (type === "checkCircle") {
    return /*#__PURE__*/_react["default"].createElement(_RadioSwitch["default"], (0, _extends2["default"])({
      onToggle: onToggle,
      active: activeState
    }, props));
  } else {
    return /*#__PURE__*/_react["default"].createElement(Switch.Ele, {
      onClick: handlerFn,
      onKeyDown: (0, _commonHelper.onKeySelect)(handlerFn),
      tabIndex: readOnly ? -1 : 0,
      size: size,
      spacing: spacing,
      totalWidth: totalWidth
    }, /*#__PURE__*/_react["default"].createElement(Toggle, {
      type: "checkbox"
    }), /*#__PURE__*/_react["default"].createElement(Switch.slider, (0, _extends2["default"])({}, props, {
      active: activeState,
      slideLength: totalWidth - (size + 2 * spacing + 1)
    })));
  }
};
Switch.Ele = _styledComponents["default"].span.withConfig({
  componentId: "sc-wnhxhf-0"
})(["position:relative;display:inline-block;width:", "rem;height:", "rem;appearance:none;outline:none;&:focus{outline:0;}"], function (_ref) {
  var totalWidth = _ref.totalWidth;
  return totalWidth / 10;
}, function (_ref2) {
  var size = _ref2.size,
    spacing = _ref2.spacing;
  return (size + 2 * spacing) / 10;
});
var Toggle = /*#__PURE__*/_styledComponents["default"].input.withConfig({
  componentId: "sc-wnhxhf-1"
})(["opacity:0;width:0;height:0;"]);
Switch.slider = _styledComponents["default"].span.withConfig({
  componentId: "sc-wnhxhf-2"
})(["position:absolute;cursor:pointer;top:0;left:0;right:0;appearance:none;bottom:0;display:inline-flex;vertical-align:middle;align-items:center;justify-content:center;margin-top:0;margin-left:0;background-color:", ";-webkit-transition:background-color ", ",opacity ", ";transition:background-color ", " ease,opacity ", ";border-radius:", "rem;outline:none;", ":focus &{box-shadow:0 0 0.5em ", ";}:before{position:absolute;content:\"\";height:", "rem;width:", "rem;left:", "rem;background-color:white;margin-top:0;margin-left:0;outline:none;border-radius:50%;transition:transform ", " ease,opacity ", ";transform:translateX( ", " );border:0.5px solid rgba(0,0,0,0.04);box-shadow:0 ", "rem 0.4rem rgba(28,28,28,0.1);&:active{outline:none;}}", ""], function (_ref3) {
  var active = _ref3.active,
    color = _ref3.color;
  return active === true ? color : "#ccc";
}, _misc["default"].shortAnimDuration, _misc["default"].shortAnimDuration, _misc["default"].shortAnimDuration, _misc["default"].shortAnimDuration, function (_ref4) {
  var size = _ref4.size,
    spacing = _ref4.spacing;
  return (size + 2 * spacing) / 10;
}, Switch.Ele, function (_ref5) {
  var active = _ref5.active,
    color = _ref5.color;
  return active ? color : "#ccc";
}, function (_ref6) {
  var size = _ref6.size;
  return size / 10;
}, function (_ref7) {
  var size = _ref7.size;
  return size / 10;
}, function (_ref8) {
  var spacing = _ref8.spacing;
  return spacing / 10;
}, _misc["default"].shortAnimDuration, _misc["default"].shortAnimDuration, function (props) {
  return props.active === true ? props.slideLength / 10 + "rem" : 0;
}, function (props) {
  return props.active === true ? 0.2 : 0.1;
}, function (props) {
  return props.readOnly ? (0, _styledComponents.css)(["opacity:0.4;"]) : (0, _styledComponents.css)(["&:active{outline:none;}"]);
});
Switch.propTypes = {
  readOnly: _propTypes["default"].bool,
  changeOnState: _propTypes["default"].bool,
  size: _propTypes["default"].number,
  spacing: _propTypes["default"].number,
  /** This gets invoked everytime switch state is changed. Final state is passed as argument */
  onToggle: _propTypes["default"].func,
  active: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["default", "checkCircle"]),
  color: _propTypes["default"].string,
  totalWidth: _propTypes["default"].number
};
Switch.defaultProps = {
  readOnly: false,
  changeOnState: false,
  size: 22,
  spacing: 2,
  onToggle: _noop2["default"],
  active: false,
  type: "default",
  color: _red["default"].z500,
  totalWidth: 38
};
var _default = exports["default"] = Switch;